export default function PHP_strspn() {
  return (
    <div>
      <h1>PHP_strspn</h1>
    </div>
  );
}
